import { useEffect, useRef, useState } from "react";
import { MessageView } from "@/interfaces/Chat";
import { useChat } from "@/contexts/ChatContext";
import { useSetChatReactionMutation } from "@/services/chat";
import { chatError } from "./CreateConversationModal";
import ReactionPicker from "./ReactionPicker";
export default function ReactionBar({
  message,
  canWrite,
}: {
  message: MessageView;
  canWrite: boolean;
}) {
  const { actorId } = useChat(),
    [mutate] = useSetChatReactionMutation();
  const [picker, setPicker] = useState(false),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  const lock = useRef(false),
    scope = useRef<object>({});
  useEffect(() => {
    scope.current = {};
    lock.current = false;
    setBusy(false);
    setError("");
    setPicker(false);
    return () => {
      scope.current = {};
    };
  }, [actorId, message.id, message.conversationId, canWrite]);
  const apply = async (emoji: string, active: boolean) => {
    if (!canWrite || !actorId || lock.current) return;
    const current = scope.current;
    lock.current = true;
    setBusy(true);
    setError("");
    setPicker(false);
    try {
      await mutate({
        actorId,
        conversationId: message.conversationId,
        messageId: message.id,
        emoji,
        active,
      }).unwrap();
    } catch (e) {
      if (scope.current === current) setError(chatError(e));
    } finally {
      if (scope.current === current) {
        lock.current = false;
        setBusy(false);
      }
    }
  };
  return (
    <>
      <div className="chat-reactions">
        {message.reactions.map((r) => (
          <button
            type="button"
            key={r.emoji}
            disabled={!canWrite || busy}
            aria-pressed={r.mine}
            aria-label={`${r.emoji}, ${r.count} réactions : ${r.users
              .map((u) => u.name)
              .join(", ")}`}
            title={r.users.map((u) => u.name).join(", ")}
            onClick={() => apply(r.emoji, !r.mine)}
          >
            {r.emoji} {r.count}
          </button>
        ))}
        {canWrite && (
          <button
            type="button"
            aria-label="Ajouter une réaction"
            disabled={busy}
            onClick={() => setPicker(true)}
          >
            ☺ +
          </button>
        )}
      </div>
      {error && <span role="alert">{error}</span>}
      {picker && (
        <ReactionPicker
          onSelect={(emoji) => apply(emoji, true)}
          onClose={() => setPicker(false)}
        />
      )}
    </>
  );
}
